import React, { useState } from 'react'
import Logo from '../assets/logo/horizontal_logo.png'
import LogoLLC from '../assets/logo/logoLLC.png'
import { Link } from "react-router-dom"
import '../styles/Header.css'
import MenuIcon from '@mui/icons-material/Menu';
import DropdownLang from './DropdownLang.tsx'
import { useTranslation } from 'react-i18next';

const Header = () => {
  const {t} = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header>
      <div className="header-top">
        <div className="logo-container">
          <Link to="/">
            <img src={Logo} alt="nutrimarket logo" className='header-logo'/>
          </Link>
          <div className="logo-divider"></div> {/* Add this line */}
          <Link to="/">
            <img src={LogoLLC} alt="nutrimarket logo" className='header-logo'/>
          </Link>
        </div>
        <div className='menu' onClick={() => setMenuOpen(!menuOpen)}>
          <MenuIcon style={{color: '#421831', fontSize: '45px'}}/>
        </div>
      </div>
        <nav className={`navbar ${menuOpen ? "open" : "close"}`}>
            <Link to="/nosotros">{t('about_us')}</Link>
            <Link to="/productos">{t('products')}</Link>
            <Link to="/servicios">{t('services')}</Link>
            <Link to="/contacto">{t('contact_us')}</Link>
            <DropdownLang />
            <Link to="/signin" className='sign-in'>
              <button className="signin-button">{t('login')}</button>
            </Link>
        </nav>
    </header>
  )
}

export default Header